import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '../types/api';

/**
 * Retry server errors and lost connections a few times (with React Query's
 * growing delay), so a short database overload during a big send does not
 * leave pages loading forever (Halloween 26/10). Never retry 4xx: those are
 * answers, not hiccups.
 */
export function shouldRetry(failureCount: number, error: unknown): boolean {
  if (failureCount >= 3) return false;
  if (error instanceof ApiError) return error.status >= 500;
  // fetch() rejects with a TypeError when the connection is lost; other
  // errors are bugs that would fail the same way again.
  return error instanceof TypeError;
}

export const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: shouldRetry, staleTime: 10_000 } },
});
